import React from 'react';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';

interface MarkdownRendererProps {
    htmlText: string,
}

const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ htmlText }) =>
    <Markdown linkTarget="_blank" remarkPlugins={[remarkGfm, remarkBreaks]}>{htmlText}</Markdown>;

export default MarkdownRenderer;